import { Chart, ArcElement, DoughnutController } from 'chart.js';
import ChartDataLabels from 'chartjs-plugin-datalabels';

Chart.register(DoughnutController);
Chart.register(ArcElement);
Chart.register(ChartDataLabels);

const createChart = (element: HTMLCanvasElement) => {
	const chartData = element.getAttribute('data-chart');
	if (!chartData) return;

	const unit = element.getAttribute('data-chart-unit') || '';

	const parsedData = JSON.parse(chartData);
	if (!parsedData) return;

	new Chart(element, {
		type: 'doughnut',
		data: {
			datasets: [
				{
					data: parsedData,
					backgroundColor: ['#96A619', '#5A0037', '#005550', '#ada48e', '#DEDBD2', '#323538'],
					borderWidth: 0,
					cutout: '75%',
					datalabels: {
						anchor: 'end',
					},
				},
			],
		},
		plugins: [
			{
				id: 'roundedDoughnut',
				beforeDatasetDraw: (chart) => {
					const { ctx } = chart;

					const x = (chart.chartArea.left + chart.chartArea.right) / 2;
					const y = (chart.chartArea.top + chart.chartArea.bottom) / 2;

					const arcs = chart.getDatasetMeta(0).data;

					/**
					 * Draw the cap of the first arc
					 */
					const arc = arcs[0];
					const radius = (arc.outerRadius + arc.innerRadius) / 2;
					const thickness = (arc.outerRadius - arc.innerRadius) / 2;

					ctx.fillStyle = arc.options.backgroundColor;
					ctx.arc(
						x,
						y - radius,
						thickness,
						0,
						2 * Math.PI,
					);
					ctx.closePath();
					ctx.fill();
				},
				afterDatasetDraw: (chart) => {
					const { ctx } = chart;

					const x = (chart.chartArea.left + chart.chartArea.right) / 2;
					const y = (chart.chartArea.top + chart.chartArea.bottom) / 2;

					const arcsOriginal = chart.getDatasetMeta(0).data;
					const arcs = [...arcsOriginal].reverse();

					arcs.forEach((arc, i) => {
						const radius = (arc.outerRadius + arc.innerRadius) / 2;
						const thickness = (arc.outerRadius - arc.innerRadius) / 2;

						 // add to avoid overlap with the start of the next arc
						const adjustment = 0.0065;

						const startAngle = Math.PI / 2 - arc.startAngle;
						const endAngle = Math.PI / 2 - arc.endAngle + adjustment;

						ctx.save();
						ctx.translate(x, y);
						ctx.fillStyle = arc.options.backgroundColor;
						ctx.beginPath();
						ctx.arc(
							radius * Math.sin(endAngle),
							radius * Math.cos(endAngle),
							thickness,
							0,
							2 * Math.PI,
						);
						ctx.closePath();
						ctx.fill();
						ctx.restore();
					});
				},
			},
			ChartDataLabels,
		],
		options: {
			layout: {
				autoPadding: false,
				padding: 30,
			},
			hover: false,
			plugins: {
				datalabels: {
					color: '#323538',
					backgroundColor: '#fff',
					borderRadius: 50,
					font: {
						size: 14,
						weight: 'bold',
					},
					textAlign: 'center',
					padding: {
						top: 14,
						bottom: 14,
						left: 6,
						right: 6,
					},
					formatter: (value) => {
						let label = value + unit;
						let padding = '';
						switch (label.length) {
							 case 1:
								padding = ' '.repeat(3);
								break;
							case 2:
								padding = ' '.repeat(2);
								break;
						}

						label = `${padding}${label}${padding}`;
						return label;
					},
				},
			},
		},
	});
};

document.addEventListener('DOMContentLoaded', () => {
	const elements = document.querySelectorAll<HTMLCanvasElement>('[data-chart]');
	elements.forEach(createChart);
});
